module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "ChFront"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("CONTENTS")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "right1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common-right.jpg"
    }
  })])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter01"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter02"
    }
  }, [_c('em', [_vm._v("Prologue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_vm._v("1 "), _c('strong', [_vm._v("TRAINS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 "), _c('strong', [_vm._v("STATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 "), _c('strong', [_vm._v("COMMUNITIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 "), _c('strong', [_vm._v("LEGACY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Sources and Suggestions for Further Reading")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0